module.exports = __webpack_public_path__ + "static/media/aboutus-irishowned-1.a9e51c59.jpg";